<template>
  <div id="app">
    <Header />
    <router-view />
    <!-- <Chat v-if="!$store.getters.isAdmin" /> -->
    <Footer />
  </div>
</template>

<script>
import { mapState } from "vuex";
import Header from "./components/Header.vue";
import Footer from "./components/Footer.vue";
import Chat from "./components/Chat.vue";
import axios from "axios";
import * as jquery_ui from "./assets/js/jquery-ui.min.js";
import * as bootstrap from "./assets/js/bootstrap.bundle.min.js";
import * as gunspring from "./assets/js/gunspring.js";
import * as fontawesome from "./assets/js/fontawesome.js";


export default {
  name: "App",
  components: {
    Header,
    Footer,
    Chat
  },
  data: () => ({
  }),
  computed: mapState(["accessToken", "userapp"]),
  watch: {
      userapp: function (update, old){
        if (update) {
          this.openChat(this.$store.getters.user_app_data);
        }
      },
  },
  beforeCreate() {},
  mounted() {
    if (this.accessToken) {
      setTimeout(()=>{
          this.openChat(this.$store.getters.user_app_data);
        },3000 )
      
      if (!this.$store.getters.isAdmin) {
      }
      this.$store.dispatch("verifyToken", this.accessToken);
    }
    axios.interceptors.response.use(undefined, function(err) {
      return new Promise(function(resolve, reject) {
        if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
          // if you ever get an unauthorized, logout the user
          this.$store.dispatch("logoutUser");
          
          return this.$router.push({ name: "login" });
          // you can also redirect to /login if needed !
        }
        throw err;
      });
    });
  },
  methods: {
    openChat(user) {

      var vm = this;
      if (!user) {
        // RocketChat(function() {
        //   this.hideWidget();
        // });
      }
      if (!this.$store.getters.isAdmin) {
        var script = document.createElement('script');
          script.src = (function (w, d, s, u) {
        w.RocketChat = function (c) { w.RocketChat._.push(c) }; w.RocketChat._ = []; w.RocketChat.url = u;
        var h = d.getElementsByTagName(s)[0], j = d.createElement(s);
        j.async = true; j.src = 'https://api.gunspring.com/rocketchat/livechat/rocketchat-livechat.min.js?_=201903270000';
        h.parentNode.insertBefore(j, h);
    })(window, document, 'script', 'https://api.gunspring.com/rocketchat/livechat');
        RocketChat(function() {
          this.setGuestToken(vm.userapp.creator);
          this.setGuestName(vm.userapp.fullname);
          this.setGuestEmail(vm.userapp.app_user);
          this.registerGuest({
          token: vm.userapp.creator, // The token field is not required. If it is not passed, a new token will be generated
          name: vm.userapp.fullname,
          email: vm.userapp.app_user,
          });
          this.showWidget();
          vm.$store.dispatch("setRocketChannel").then(() =>{
          vm.$store.dispatch("getMessageHistory")
          });
        });
      }
    }
  }
};
</script>

<style>
@import "https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:wght@300;400;500;600;700&display=swap";
@import "./assets/styles/style.css";
@import "./assets/styles/bootstrap.min.css";
@import "./assets/styles/all.min.css";
</style>
